import { Tc, PagingResultsViewModel } from "../../../core/_infrastructure/types/common";


export class GrupoPaisFrItemResultsViewModel extends PagingResultsViewModel {

    public ResultList: GrupoPaisFrViewModel [];
}

export class GrupoPaisFrViewModel {

    constructor()
    {
        
    }
    
    public Id: number;
    public Descripcion: string = '';    
}








